import Vue from "vue";
import {Transfer,ConfigProvider,Popover,Checkbox,Table} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import '../assets/css/detail.css';
Vue.use(Transfer);
Vue.use(ConfigProvider);
Vue.use(Popover);
Vue.use(Checkbox);
Vue.use(Table);